module.exports = __webpack_public_path__ + "static/2-f1925808d2ceac679e80433a3de4b673.png";